import { render, staticRenderFns } from "./StatsElectricChart.vue?vue&type=template&id=9395fe98&scoped=true"
import script from "./StatsElectricChart.vue?vue&type=script&lang=ts"
export * from "./StatsElectricChart.vue?vue&type=script&lang=ts"
import style0 from "./StatsElectricChart.vue?vue&type=style&index=0&id=9395fe98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9395fe98",
  null
  
)

export default component.exports